import Vue from 'vue';
import Router from 'vue-router';
import Index from './pages/Index.vue';
import Landing from './pages/Landing.vue';
import CompareIndex from './pages/CompareIndex.vue';
import Support from './pages/Support.vue';
import TermsOfUse from './pages/TermsOfUse.vue';
import QnA from './pages/QnA.vue';
import Testing from './pages/Testing.vue';
import Login from './pages/Login.vue';
import Profile from './pages/Profile.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainNavigationBar from './layout/MainNavigationBar.vue'
import MainFooter from './layout/MainFooter.vue';


Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/index',
      name: 'index',
      components: { default: Index, header: MainNavigationBar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/',
      name: 'landing',
      components: { default: Landing},
    },
    {
      path: '/compare',
      name: 'compare-index',
      components: { default: CompareIndex },
    },
    {
      path: '/compare/:slug',
      name: 'compare',
      components: { default: Landing },
    },
    {
      path: '/support',
      name: 'support',
      components: { default: Support}      
    },
    {
      path: '/qna',
      name: 'qna',
      components: { default: QnA},      
    },
    {
      path: '/termsofuse',
      name: 'termsofuse',
      components: { default: TermsOfUse},      
    },
    {
      path: '/login',
      name: 'login',
      components: { default: Login, header: MainNavbar },
      props: {
        header: { colorOnScroll: 400 }
      }
    },
    {
      path: '/profile',
      name: 'profile',
      components: { default: Profile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/testing',
      name: 'testing',
      components: { default: Testing, header: MainNavigationBar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 200 },
        footer: { backgroundColor: 'black' }
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.path === '/compare' && to.hash) {
      return { x: 0, y: 0 };
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});
